<script>
    import { currentUser, selectedItem, searchTerm } from '../store/store.js';
    import { handleLogout } from '../utils/login';
    import { Link } from "svelte-routing";

    function clearSelectedItem() {
        selectedItem.set(null);
        searchTerm.set('');
    }
</script>

<div class="top-bar">
    <div class="rectangle left"></div>
    <div class="rectangle middle">
        <Link to="/" class="link" on:click={clearSelectedItem}>Hem</Link>
        <Link to="/about" class="link">Om Oss</Link>
        {#if !$currentUser?.accessToken}
            <Link to="/login" class="link">Logga in</Link>
        {:else}
            <Link to="/profile" class="link">Profil</Link>
            <button on:click={handleLogout} class="link">Logga ut</button>
        {/if}
    </div>
    <div class="rectangle right"></div>
</div>


<style>
    .top-bar {
  display: flex;
  align-items: flex-start; /* Aligns rectangles to the top */
  justify-content: space-between; /* Distributes space between rectangles */
  width: 100%;
  height: 40px; /* Height of the tallest rectangle */
  background-color: transparent; /* Optional: background color for the top bar */
  position: relative; /* Needed for positioning the triangles */
}

    .middle {
    width: 30%; /* Adjust width as needed */
    min-width: 355px;
    height: 40px;
    border-bottom: 2px solid var(--top-bar-border); /* Add a bottom border */
    display: flex; /* Use flexbox to align links */
    align-items: center; /* Vertically center the links */
    justify-content: center; /* Horizontally center the links */
    gap: 20px; /* Add space between the links */
    }

    .left::after {
    content: '';
    position: absolute;
    right: -0px; /* Adjust based on the width of the triangle */
    top: 20px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 20px 20px 0 0; /* Flipped vertically */
    border-color: var(--primary-color) transparent transparent transparent; /* Match the rectangle color */
    z-index: 1; /* Higher z-index to ensure it's above other elements */
    transform: rotate(90deg);
    }

    /* Add a border to the left triangle */
    .left::before {
    content: '';
    position: absolute;
    right: 0px; /* Slightly offset to create the border effect */
    top: 21px; /* Slightly offset to create the border effect */
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 21px 21px 0 0; /* Slightly larger than the main triangle */
    border-color: var(--top-bar-border) transparent transparent transparent; /* Border color */
    z-index: 0; /* Place it behind the main triangle */
    transform: rotate(90deg);
    }

    /* Triangle between middle and right (flipped vertically) */
    .middle::after {
    content: '';
    position: absolute;
    right: -20px; /* Adjust based on the width of the triangle */
    top: 20px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 20px 20px 0; /* Flipped vertically */
    border-color: transparent var(--primary-color) transparent transparent; /* Match the rectangle color */
    z-index: 1; /* Higher z-index to ensure it's above other elements */
    transform: rotate(270deg);
    }

    /* Add a border to the middle triangle */
    .middle::before {
    content: '';
    position: absolute;
    right: -21px; /* Slightly offset to create the border effect */
    top: 21px; /* Slightly offset to create the border effect */
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 21px 21px 0; /* Slightly larger than the main triangle */
    border-color: transparent var(--top-bar-border) transparent transparent; /* Border color */
    z-index: 0; /* Place it behind the main triangle */
    transform: rotate(270deg);
    }

    @media (max-width: 768px) {
        .middle {
            gap: 10px;
        }
    }
</style>
